import { Contact, Globe, Hand, Monitor, QrCode } from 'lucide-vue-next'
import type { Component } from 'vue'

export type RecoveryMethodKey = 'qr_code' | 'seller_validation' | 'cash_register' | 'kiosk' | 'online'

export interface RecoveryMethodMeta {
  key: RecoveryMethodKey
  icon: Component
}

export const RECOVERY_METHODS: RecoveryMethodMeta[] = [
  { key: 'qr_code', icon: QrCode },
  { key: 'seller_validation', icon: Hand },
  { key: 'cash_register', icon: Contact },
  { key: 'kiosk', icon: Monitor },
  { key: 'online', icon: Globe }
]

export const getMethodMeta = (key: RecoveryMethodKey): RecoveryMethodMeta =>
  RECOVERY_METHODS.find((m) => m.key === key) as RecoveryMethodMeta
